import queryString from "query-string";
import projectWizardUtils from "../projectWizard/projectWizardUtils.js";
import { CONNECTIONS, PROJECTS } from "../../actions/actionConstants.js";
import { ENDPOINTS } from "../../../constants/api.js";

export const getProjects = (
  searchParams,
  charge = false,
  usage = false,
  options
) => {
  return {
    type: PROJECTS.GET,
    payload: {
      endpoint: ENDPOINTS.PROJECTS,
      ...queryString.parse(searchParams),
      charge,
      usage
    },
    options
  };
};

export const getProject = (id, charge, usage, resources) => {
  return {
    type: PROJECTS.GET,
    payload: { "@id": id, id, charge, usage, resources }
  };
};

// data structure build could be done before the action is called?
export const createProject = (panels, id) => {
  return (dispatch, getState) => {
    const payload = projectWizardUtils.buildProjectCreationData(
      getState(),
      panels,
      id
    );

    if (payload) {
      dispatch({
        type: PROJECTS.POST,
        payload
      });
    } else {
      const error = `WARNING: Invalid project detail arguments supplied.`;
      console.error(error);
      dispatch({ type: "internal-error", payload: { error } });
    }
  };
};

// temp to help test functionality - will be replaced with an operations call soon
export const getProjectConnections = (id, searchParams, options) => {
  return {
    type: CONNECTIONS.GET,
    payload: {
      endpoint: `${id}/connections`,
      ...queryString.parse(searchParams)
    },
    options
  };
};

export const updateProjectConnections = (data, searchParams) => {
  return {
    type: CONNECTIONS.PUT,
    payload: {
      endpoint: data["@id"],
      searchParams,
      ...data
    }
  };
};

export default {};
